/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type BackofficeUpdatesQueryVariables = Types.Exact<{
  [key: string]: never
}>

export type BackofficeUpdatesQuery = {
  __typename?: 'Query'
  backofficeOrganizations: Array<{
    __typename?: 'BackofficeOrganization'
    id: string
    name: string
  }>
  backofficeUpdates: {
    __typename?: 'BackofficeUpdatesResponse'
    total: number
    updates: Array<{
      __typename?: 'BackofficeUpdate'
      id: string
      creationDate: string
      type: Types.BackofficeUpdateType
      title: string
      description: string
      link: string | null
      images: Array<string | null> | null
      organizations: Array<string>
    }>
  }
}

export const BackofficeUpdatesDocument = gql`
    query backofficeUpdates {
  backofficeOrganizations {
    id
    name
  }
  backofficeUpdates {
    total
    updates {
      id
      creationDate
      type
      title
      description
      link
      images
      organizations
    }
  }
}
    `

/**
 * __useBackofficeUpdatesQuery__
 *
 * To run a query within a React component, call `useBackofficeUpdatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBackofficeUpdatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBackofficeUpdatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useBackofficeUpdatesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BackofficeUpdatesQuery,
    BackofficeUpdatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    BackofficeUpdatesQuery,
    BackofficeUpdatesQueryVariables
  >(BackofficeUpdatesDocument, options)
}
export function useBackofficeUpdatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BackofficeUpdatesQuery,
    BackofficeUpdatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    BackofficeUpdatesQuery,
    BackofficeUpdatesQueryVariables
  >(BackofficeUpdatesDocument, options)
}
// @ts-ignore
export function useBackofficeUpdatesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    BackofficeUpdatesQuery,
    BackofficeUpdatesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  BackofficeUpdatesQuery,
  BackofficeUpdatesQueryVariables
>
export function useBackofficeUpdatesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        BackofficeUpdatesQuery,
        BackofficeUpdatesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  BackofficeUpdatesQuery | undefined,
  BackofficeUpdatesQueryVariables
>
export function useBackofficeUpdatesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        BackofficeUpdatesQuery,
        BackofficeUpdatesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    BackofficeUpdatesQuery,
    BackofficeUpdatesQueryVariables
  >(BackofficeUpdatesDocument, options)
}
export type BackofficeUpdatesQueryHookResult = ReturnType<
  typeof useBackofficeUpdatesQuery
>
export type BackofficeUpdatesLazyQueryHookResult = ReturnType<
  typeof useBackofficeUpdatesLazyQuery
>
export type BackofficeUpdatesSuspenseQueryHookResult = ReturnType<
  typeof useBackofficeUpdatesSuspenseQuery
>
export type BackofficeUpdatesQueryResult = Apollo.QueryResult<
  BackofficeUpdatesQuery,
  BackofficeUpdatesQueryVariables
>
